import React, { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import { GridOptions } from "ag-grid-community";

import { DataTableProps } from "./types/types";
import { getPresetConfig } from "./presets/presets";
import { registerAgGridModules } from "./util/registerModules";
import { deepMerge } from "./util/deepMerge";

// Register AG Grid modules on import
registerAgGridModules(
  (import.meta.env["VITE_REACT_APP_AG_GRID_LICENSE_KEY"] as
    | string
    | undefined) || "",
);

export const BaseDataTable = React.forwardRef<AgGridReact, DataTableProps>(
  (
    { configure = {}, gridOptions: userGridOptions = {}, ...agGridProps },
    ref,
  ) => {
    const { preset = "default" } = configure;

    const mergedGridOptions = useMemo((): GridOptions => {
      const presetConfig = getPresetConfig(preset);
      return deepMerge<GridOptions>(presetConfig, userGridOptions);
    }, [preset, userGridOptions]);

    return (
      <div style={{ width: "100%" }}>
        <AgGridReact
          domLayout="autoHeight"
          ref={ref}
          {...agGridProps}
          {...mergedGridOptions}
        />
      </div>
    );
  },
);

BaseDataTable.displayName = "BaseDataTable";
